import axios from "axios";

import { baseUrl } from "./baseUrl";
import { uploadImage, updateImage } from './imageApiV2';
import { FaExternalLinkSquareAlt } from "react-icons/fa";

// Home page organizer api
const api = axios.create({
    baseURL: `${baseUrl}/admin/homepage-organizer`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Add request interceptor to dynamically set the token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('cc-t') || sessionStorage.getItem('cc-t');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// quiz aip
const quizApi = axios.create({
    baseURL: `${baseUrl}/admin/quiz`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export const getChallengeOfTheDay = async () => {
    try {
        const res = await api.get("/challenge-of-the-day");
        return res.data.challengeOfTheDay;
    } catch (err) {
        console.log(err);
    }
}

export const setNewChallengeOfTheDay = async (data) => {
    try {
        const res = await api.post("/challenge-of-the-day", data);
        return res.data.challengeOfTheDay;
    } catch (err) {
        console.log(err);
    }
}

export const getAppDisplayConfig = async () => {
    try {
        const res = await api.get("/get-app-display-configs");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setAppDisplayConfig = async (data) => {
    try {
        const res = await api.post("/update-app-display-configs", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setEcoQuizzes = async (data) => {
    try {
        const res = await quizApi.put("/set-quiz", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

// Hero Section
export const getHeroSection = async () => {
    try {
        const res = await api.get("/hero-section");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setHeroSection = async (data, heroImage1, heroImage2, deleteHeroImage1, deleteHeroImage2) => {
    try {
        console.log('Starting hero section update with data:', data);
        // Handle heroImage1 deletion
        // if (deleteHeroImage1) {
        //     console.log('🗑️ Deleting hero image 1');
        //     data.heroImage1Id = null;
        //     data.heroImage1Version = null;
        //     data.heroImage1 = null;
        // } 
        // Upload heroImage1 to Image API V2 if provided
        if (heroImage1 && heroImage1 instanceof File) {
            console.log('📤 Uploading hero image 1 to Image API V2...');

            // Use updateImage if heroImage1Id exists, otherwise upload new
            let imageResult1;
            if (data.heroImage1Id) {
                imageResult1 = await updateImage(data.heroImage1Id, heroImage1);
                console.log('✅ Hero image 1 updated to version:', imageResult1.version);
            } else {
                imageResult1 = await uploadImage(heroImage1, 'homepage-hero', false);
                console.log('✅ Hero image 1 uploaded:', imageResult1);
            }

            // Add Image API V2 metadata to data
            data.heroImage1Id = imageResult1.imageId;
            data.heroImage1Version = imageResult1.version;
            data.heroImage1 = imageResult1.url;
        }
        else {
            if (deleteHeroImage1) {
                console.log('🗑️ Deleting hero image 1');
                data.heroImage1Id = null;
                data.heroImage1Version = null;
                data.heroImage1 = null;
            }
        }

        // Handle heroImage2 deletion

        // Upload heroImage2 to Image API V2 if provided
        if (heroImage2 && heroImage2 instanceof File) {
            console.log('📤 Uploading hero image 2 to Image API V2...');

            // Use updateImage if heroImage2Id exists, otherwise upload new
            let imageResult2;
            if (data.heroImage2Id) {
                imageResult2 = await updateImage(data.heroImage2Id, heroImage2);
                console.log('✅ Hero image 2 updated to version:', imageResult2.version);
            } else {
                imageResult2 = await uploadImage(heroImage2, 'homepage-hero', false);
                console.log('✅ Hero image 2 uploaded:', imageResult2);
            }

            // Add Image API V2 metadata to data
            data.heroImage2Id = imageResult2.imageId;
            data.heroImage2Version = imageResult2.version;
            data.heroImage2 = imageResult2.url;
        }
        else if (deleteHeroImage2) {
            console.log('🗑️ Deleting hero image 2');
            data.heroImage2Id = null;
            data.heroImage2Version = null;
            data.heroImage2 = null;
        }

        const res = await api.put("/hero-section", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Do You Know Section
export const getDoYouKnowSection = async () => {
    try {
        const res = await api.get("/do-you-know-challenges");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setDoYouKnowSection = async (data) => {
    try {
        const res = await api.post("/do-you-know-challenges", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

// More Challenges Section
export const getMoreChallengesSection = async () => {
    try {
        const res = await api.get("/more-challenges");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setMoreChallengesSection = async (data) => {
    try {
        const res = await api.post("/more-challenges", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

// Blogs Section
export const getBlogsSection = async () => {
    try {
        const res = await api.get("/blogs");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setBlogsSection = async (data) => {
    try {
        const res = await api.post("/blogs", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

// Events Section
export const getEventsSection = async () => {
    try {
        const res = await api.get("/events");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setEventsSection = async (data) => {
    try {
        const res = await api.post("/events", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

// Partners
export const getPartnersSection = async () => {
    try {
        const res = await api.get("/partners");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setPartnersSection = async (data) => {
    try {
        const res = await api.post("/partners", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

// Eco Activities Section
export const getEcoActivitiesSection = async () => {
    try {
        const res = await api.get("/eco-activities");
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}

export const setEcoActivitiesSection = async (data) => {
    try {
        const res = await api.post("/eco-activities", data);
        return res.data.data;
    } catch (err) {
        console.log(err);
    }
}